import axios from '../../utils/axios'
import store from '../store'
import { getFormattedDate } from '../../utils/helpers'
import { saveAs } from 'file-saver'

export const SEARCH_PACKAGES_LOADER = 'SEARCH_PACKAGES_LOADER'
export const GET_PACKAGES = 'GET_PACKAGES'
export const GET_PACKAGES_ERROR = 'GET_PACKAGES_ERROR'
export const GET_DELIVERY_METHODS = 'GET_DELIVERY_METHODS'
export const GET_DELIVERY_METHODS_ERROR = 'GET_DELIVERY_METHODS_ERROR'
export const CANCEL_PACKAGE_SUCCESS = 'CANCEL_PACKAGE_SUCCESS'
export const CANCEL_PACKAGE_ERROR = 'CANCEL_PACKAGE_ERROR'
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS'
export const GET_PACKAGE_PDF_ERROR = 'GET_PACKAGE_PDF_ERROR'

export const GetDeliveryMethods = () => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'get',
    baseURL: config.baseURL,
    url: '/package/deliverymethods',
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return (dispatch) => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then((response) => {
        dispatch(GetDeliveryMethodsSuccess(response.data.DeliveryMethods))
      })
      .catch(error => {
        console.log(`DeliveryMethods error is: ${error.message}`)
        dispatch(GetDeliveryMethodsError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetLoading(false))
        setTimeout(() => {
          dispatch(GetDeliveryMethodsError(''))
        }, 5000)
      })
  }
}

function _base64ToArrayBuffer (base64) {
  var binaryString = window.atob(base64)
  var len = binaryString.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}

export const GetPackagePDF = (packageId) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    url: config.baseURL + '/package/pdf',
    data: {
      PackageId: packageId.toString()
    },
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return (dispatch) => {
    return axios(axiosConfig)
      .then((response) => {
        var pdfData = _base64ToArrayBuffer(response.data.PackagePDF)
        var file = new Blob([pdfData], { type: 'application/pdf' })
        saveAs(file, `${packageId}.pdf`)
      })
      .catch(error => {
        console.log(`GetPackagePDF error is: ${error.message}`)
        dispatch(GetPackagePDFError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
  }
}

export const SearchPackages = (query, deliveryMethods) => {
  const types = []
  deliveryMethods.map((type) => {
    types.push(type.Id)
  })

  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    url: config.baseURL + '/package/search',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      SearchTerm: query,
      DeliveryMethods: types
    }
  }

  return (dispatch) => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then((response) => {
        response.data.PackageSearchResult.map((r) => {
          // DataGrid requires a unique id be passed to it
          r.id = r.PackageId
          r.ApplicationDate = getFormattedDate(r.ApplicationDate)
          // needs to be in date format in order to be sorted properly within the table
          r.Printed = new Date(r.Printed)
        })
        dispatch(GetPackages(response?.data?.PackageSearchResult))
      })
      .catch(error => {
        console.log(`SearchPackages error is: ${error.message}`)
        dispatch(GetPackagesError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetLoading(false))
        setTimeout(() => {
          dispatch(GetPackagesError(''))
        }, 5000)
      })
  }
}

export const CancelPackage = (id) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'put',
    url: config.baseURL + '/package/cancel',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      PackageId: id
    }
  }

  return (dispatch) => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then(() => {
        dispatch(CancelPackageSuccess(true))
      })
      .catch(error => {
        console.log(`CancelPackage error is: ${error.message}`)
        dispatch(CancelPackageError(error?.response?.data?.Message ? (error?.response?.data?.Message + ': ' + error.message) : error.message))
      })
      .finally(() => {
        dispatch(SetLoading(false))
        dispatch(CancelPackageSuccess(false))
        setTimeout(() => {
          dispatch(CancelPackageError(''))
        }, 5000)
      })
  }
}

export const SetLoading = (loading) => {
  return {
    type: SEARCH_PACKAGES_LOADER,
    loading
  }
}

export const ClearSearchResults = () => {
  return {
    type: CLEAR_SEARCH_RESULTS,
    results: []
  }
}

export const GetPackagePDFError = (error) => {
  return {
    type: GET_PACKAGE_PDF_ERROR,
    error
  }
}

export const GetPackages = (packages) => {
  return {
    type: GET_PACKAGES,
    packages
  }
}

export const GetPackagesError = (error) => {
  return {
    type: GET_PACKAGES_ERROR,
    error
  }
}

export const GetDeliveryMethodsSuccess = (methods) => {
  return {
    type: GET_DELIVERY_METHODS,
    deliveryMethods: methods
  }
}

export const GetDeliveryMethodsError = (error) => {
  return {
    type: GET_DELIVERY_METHODS_ERROR,
    error
  }
}

export const CancelPackageSuccess = (isSuccess) => {
  return {
    type: CANCEL_PACKAGE_SUCCESS,
    cancelPackageSuccess: isSuccess
  }
}

export const CancelPackageError = (error) => {
  return {
    type: CANCEL_PACKAGE_ERROR,
    error
  }
}
